export default __webpack_public_path__ + "static/media/kesariya.470e8d90.jpg";